import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import api from './plugins/api'
import apiv2 from './plugins/apiv2'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify';
import viewer from 'v-viewer'
import tracking from './plugins/tracking'
import '@/assets/tailwind.scss'
import 'viewerjs/dist/viewer.css'
import './plugins/matomo'

if (!Vue.prototype.$tracking) {
    Vue.prototype.$tracking = tracking
}

if (!Vue.prototype.$api) {
    Vue.prototype.$api = api
}

if (!Vue.prototype.$apiv2) {
    Vue.prototype.$apiv2 = apiv2
}

Vue.use(viewer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
